import React from "react";
import { useAppContext } from "../contexts/AppContext";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const Dashboard = () => {
  const { tasks, contacts, analytics } = useAppContext();

  const taskData = tasks.reduce((acc, task) => {
    const month = new Date(task.createdAt).toLocaleString("default", {
      month: "short",
    });
    acc[month] = (acc[month] || 0) + 1;
    return acc;
  }, {});

  const data = Object.keys(taskData).map((key) => ({
    month: key,
    tasks: taskData[key],
  }));

  return (
    <div>
      <h2>Analytics Dashboard</h2>
      <div>
        <h3>Total Contacts: {analytics.totalContacts}</h3>
        <h3>Total Tasks: {analytics.totalTasks}</h3>
      </div>
      <h3>Tasks Completed Over Time</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="tasks" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Dashboard;
